import {
  CheckNotes,
  InspectionCase,
  InspectionRiskLevelsCase,
  InspectionRiskLevelsCaseDto,
  InspectionWaterSupplyDataCase,
  InspectionWaterSupplyDataCaseDto
} from '../../inspection-cases';

export class SprinklerSystemDesignMainDto extends InspectionCase {
  isSafetyPlansSubmitted?: InspectionCase;
  structureRisks?: InspectionRiskLevelsCaseDto;
  waterSupplyDescription?: InspectionCase;
  cityWaterSupplyCharacteristics?: InspectionWaterSupplyDataCaseDto;
  plumberRoomWaterSupplyCharacteristics?: InspectionWaterSupplyDataCaseDto;
}

export class SprinklerSystemDesignMain extends SprinklerSystemDesignMainDto {
  constructor(data: SprinklerSystemDesignMainDto = { title: 'תכנון - כללי' }) {
    super(data);
    this.isSafetyPlansSubmitted = new InspectionCase({
      ...data.isSafetyPlansSubmitted,
      title: 'האם הוגשו תכניות בטיחות?'
    });
    this.structureRisks = new InspectionRiskLevelsCase({
      ...data.structureRisks,
      title: 'פרט את תפוסות הסיכון השונות במבנה'
    });
    this.waterSupplyDescription = new InspectionCase({
      ...data.waterSupplyDescription,
      title: 'תאר את מקור אספקת המים המתכנן למערכות המתזים / אביזרי קצה'
    });
    this.cityWaterSupplyCharacteristics = new InspectionWaterSupplyDataCase({
      ...data.cityWaterSupplyCharacteristics,
      title:
        'במידה ואספקת המים למערכת המתזים הינה מרשת עירונית ציין את הספיקות והלחצים שהתקבלו ע"י המעבדה'
    });
    this.plumberRoomWaterSupplyCharacteristics = new InspectionWaterSupplyDataCase(
      {
        ...data.plumberRoomWaterSupplyCharacteristics,
        title:
          'במידה ואספקת המים למערכת המתזים הינה מחדר משאבות ציין את נתוני המשאבה/ות'
      }
    );
  }

  setInspectionStatus(): void {
    this.isPassed =
      !this.isApplicable ||
      ((!this.isSafetyPlansSubmitted.isApplicable ||
        this.isSafetyPlansSubmitted.isPassed) &&
        (!this.structureRisks.isApplicable || this.structureRisks.isPassed) &&
        (!this.waterSupplyDescription.isApplicable ||
          this.waterSupplyDescription.isPassed) &&
        (!this.cityWaterSupplyCharacteristics.isApplicable ||
          this.cityWaterSupplyCharacteristics.isPassed) &&
        (!this.plumberRoomWaterSupplyCharacteristics.isApplicable ||
          this.plumberRoomWaterSupplyCharacteristics.isPassed));
  }

  getNotes?(): CheckNotes[] {
    if (!this.isApplicable) {
      return [];
    }
    return [
      ...this.isSafetyPlansSubmitted.getNotes(),
      ...this.structureRisks.getNotes(),
      ...this.waterSupplyDescription.getNotes(),
      ...this.cityWaterSupplyCharacteristics.getNotes(),
      ...this.plumberRoomWaterSupplyCharacteristics.getNotes()
    ];
  }
}
